import computed from './attrs/computed'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'

import Loading from './../Loading/Index'
import Header from './../Header/Index'
import Footer from './../Footer/Index'
import CookiesAlert from './../CookiesAlert/Index'
import WhatsappCta from './../WhatsappCta/Index'

export default {
    name: 'App',
    computed,
    methods,
    mounted,
    watch,
    components: {
        Loading,
        Header,
        Footer,
        CookiesAlert,
        WhatsappCta
    }
}
